<div class="flex justify-between">
  <rk-page-title [title]="'SCHEDULE.PLANNING.BREAKS' | translate"></rk-page-title>
  <rk-button
    class="block md:hidden"
    [label]="(currentDay$ | async)?.format('MMMM YYYY')"
    [btnStyle]="'flat'"
    (click)="selectDate()"
  ></rk-button>
</div>
<div class="text-gray-darkest -mt-3 mb-2 hidden md:block" translate>
  SCHEDULE.PLANNING.BREAK_HINT
</div>

<div class="planning-header--actions hidden md:flex">
  @if (!(selectedBreaks$ | async)) {
    <rk-button
      data-cy="add-break"
      [label]="'SCHEDULE.PLANNING.ADD_BREAK' | translate"
      [disabled]="
        !(
          (hasPrograms$ | async) ||
          (hasPlaylists$ | async) ||
          (tracks$ | async)?.length > 0
        )
      "
      rkTooltip
      [tooltipDescription]="'SCHEDULE.PLANNING.NO_PROGRAM_PLAYLIST_TRACK' | translate"
      [tooltipDisabled]="
        (hasPrograms$ | async) || (hasPlaylists$ | async) || (tracks$ | async)?.length > 0
      "
      faIcon="fa-plus"
      (click)="addBreakClicked()"
    ></rk-button>
    <rk-date-select
      class="planning-header--actions-datepicker"
      [calendarDatesChanged]="calendarDatesChanged"
      (dateSelectDatesChanged)="dateSelectDatesUpdated($event)"
    ></rk-date-select>
    <rk-button
      class="planning-header--actions-previous"
      btnStyle="flat"
      faIcon="fa-angle-left"
      [squarePadding]="true"
      (click)="calendarPreviousClicked()"
    ></rk-button>
    <rk-button
      class="planning-header--actions-next"
      btnStyle="flat"
      faIcon="fa-angle-right"
      [squarePadding]="true"
      (click)="calendarNextClicked()"
    ></rk-button>
    <rk-button
      class="planning-header--actions-now"
      [label]="'SCHEDULE.PLANNING.NOW' | translate"
      btnStyle="flat"
      (click)="calendarTodayClicked()"
    ></rk-button>
  } @else {
    <div class="flex items-center">
      <span
        [innerHTML]="
          'SCHEDULE.PLANNING.BREAKS_SELECTED'
            | translate: { count: (selectedBreaks$ | async) }
        "
      ></span>
      <rk-button
        class="planning-header--actions-now"
        [label]="'SCHEDULE.PLANNING.DELETE_ALL_SELECTED_BREAKS' | translate"
        [faIcon]="'fa-trash-alt'"
        btnStyle="delete"
        (click)="deleteBreaks()"
      ></rk-button>
    </div>
  }
</div>
